import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getSalesChannel(id) {
    return RetailerApiClient.get('sales-channels/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getProducts(salesChannelId) {
    return RetailerApiClient.get('sales-channels/' + salesChannelId + '/products')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPaymentMethods(salesChannelId) {
    return RetailerApiClient.get('sales-channels/' + salesChannelId + '/payment-methods')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  searchProduct(salesChannelId, query) {
    return RetailerApiClient.get('sales-channels/' + salesChannelId + '/products', { params: { keyword: query } })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrSearchAllProducts(params) {
    const query = params.query ?? ''
    return RetailerApiClient.post('products/search?keyword=' + query, { items: params.items })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
